import {getErrorMessage, serializeMacro} from '../../Form/serializers/form';
import {formsStore} from '../../Form/stores/FormsStore';
import {MacroData} from '../../Form/types';
import {getDataSetJson} from '../../../_shared/GWTBridge/invoke/common';
import {returnFocus} from '../../../_shared/GWTBridge/invoke/genPage';
import {
    activateMacro,
    addMacroAction,
    startRecordingMacro,
    stopMacroMsg,
    stopRecordingMacro,
    toggleRecursiveActionAndReturnData
} from '../../../_shared/GWTBridge/invoke/netForm';
import {
    showConfirmMessage,
    showInfoMessage
} from '../../../_shared/Messages/actions/MessageActions';
import {deleteMacro, macroKey, macroRecord} from '../../../services/macroService';
import {macroFooterRef} from '../constants';
import texts from '../texts';
import {automationMenuTriggerRef} from '../components/automationMenuTriggerRef';
import {featurePopoverRef} from '../../../features/FeaturePopover/FeaturePopover.root';

export const onDeleteMacro = macroID => {
    formsStore.currentForm?.removeMacro(macroID);
    deleteMacro(formsStore.currentForm, macroID);
};

export const startRecording = async (name, key, isRecursive) => {
    const data: any = await macroRecord(formsStore.currentForm, '0', name, false, null);
    const json = getDataSetJson(data);
    const error = getErrorMessage(json);
    if (error) {
        showInfoMessage({title: error});
        return false;
    }
    const macro = serializeMacro(json);
    if (macro) {
        macro.isRecursive = isRecursive;
        formsStore.setCurrentRecordingMacro(macro);
        startRecordingMacro(data);
        if (key) {
            setMacroKey(macro.macro, key);
            macro.key = key;
        }
        formsStore.currentForm?.addMacro(macro);
    }

    macroFooterRef.current?.showFooter(true);
    return true;
};

export const stopRecording = () => {
    stopRecordingMacro(formsStore.currentRecordingMacro.isRecursive);
    showInfoMessage({
        title: texts.saveMacroMsg.replace('XXX', formsStore.currentRecordingMacro?.origtitle),
        onClose: () => returnFocus()
    });
    formsStore.setCurrentRecordingMacro(null);
};

export const startMacro = async macroID => {
    if (formsStore.currentRecordingMacro) {
        addMacroAction(macroID);
    } else {
        const data = await macroRecord(formsStore.currentForm, macroID, '', true, null);
        if (isRecursiveByActions(data, macroID)) {
            const title = texts.msg_startRecursiveMacro
                .replace('XXX', getMacroNameById(macroID))
                .replace('X', formsStore.currentForm.maxRecursiveMacro);
            showConfirmMessage({
                title,
                isRemovable: true,
                onConfirm: () => runMacro(macroID, data),
                confirmButtonText: texts.dlg_yes,
                cancleButtonText: texts.dlg_no,
                defaultButton: 0,
                id: 'macro_recursive_msg',
                onClose: () => returnFocus()
            });
        } else {
            runMacro(macroID, data);
        }
    }
};

const runMacro = (macroID, data) => {
    macroFooterRef.current?.showFooter();
    activateMacro(macroID, data);
};

export const setMacroKey = async (macroID, key) => {
    if (key) {
        await macroKey(formsStore.currentForm, macroID, key);
        formsStore.currentForm?.updateMacroKey(macroID, key);
    }
};

export const getMacroActionsFromServer = async macroID => {
    const data: any = await macroRecord(formsStore.currentForm, macroID, '', true, false);
    return data;
};

export const updateMacroRecursive = async (macroID, dataSet, isRecursive) => {
    const xml = toggleRecursiveActionAndReturnData(macroID, dataSet, isRecursive);
    return await macroRecord(formsStore.currentForm, macroID, '', false, xml, false, false);
};

export const isRecursiveByActions = (data, macroID: number) => {
    const json = getDataSetJson(data);
    const actions: any[] = json?.Form?.[0]?.MacroActions;
    return actions?.some(
        act =>
            (act.par1 === 'Macro' && act.par2 == macroID) ||
            (act.par2 == 'Macro' && act.par3 == macroID)
    );
};

export const isMacroRecursive = async macroID => {
    const macroActions = await getMacroActionsFromServer(macroID);
    if (macroActions) {
        return isRecursiveByActions(macroActions, macroID);
    }
    return false;
};

export const getMacroSameName = (name, id): MacroData =>
    formsStore.currentForm?.macros?.find(
        macro => macro.origtitle === name && macro.macro !== id.toString()
    );

export const getMacroSameKey = (key, id): MacroData => {
    if (key) {
        return formsStore.currentForm?.macros?.find(
            macro => macro.key === key && macro.macro !== id.toString()
        );
    }
    return null;
};

export const getMacroIdByKey = key => {
    return formsStore.currentForm?.macros?.find(macro => macro.key === key)?.macro;
};

export const getMacroNameById = id => {
    return formsStore.currentForm?.macros?.find(macro => macro.macro === id)?.origtitle;
};

export const stopMacroMessage = () => {
    stopMacroMsg(texts.footer_stopMacroMessage);
};

export function showAutomationFeature(featuresID) {
    featurePopoverRef?.current?.showFeaturePopover(
        featuresID,
        automationMenuTriggerRef?.current,
        null,
        null
    );
}
